import initialState from './initialState';
import {
  UPDATE_AUTHENTICATION_METHOD,
  UPDATE_AUTHENTICATION_METHOD_DONE,
  UPDATE_AUTHENTICATION_METHOD_ERROR,
  UPDATE_AUTHENTICATION_METHOD_LOADING,
  UPDATE_AUTHENTICATION_METHOD_SUCCESS
} from '../actions/actionTypes';

// handles Configuration defaults related actions

const reducerAuthentication = (state, action) => {
  switch (action.type) {
    case UPDATE_AUTHENTICATION_METHOD_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    case UPDATE_AUTHENTICATION_METHOD_SUCCESS:
      return {
        ...state,
        error: null
      };
    case UPDATE_AUTHENTICATION_METHOD_ERROR:
      return {
        ...state,
        error: action.error
      };
    case UPDATE_AUTHENTICATION_METHOD_DONE:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  if (action.type.startsWith(UPDATE_AUTHENTICATION_METHOD)) {
    return reducerAuthentication(state, action);
  } else {
    return state;
  }
};
